import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import "./stage2.css";
import lapImg from "./images/lap.png";
import suspectImg from "./images/Suspects.png";
import Swal from "sweetalert2";
import { updateReport, fetchReport } from "../../scoreservice";


const TOTAL_ITEMS = ["number1", "number2", "number3"];
const STAGE = 2;

const timeToSeconds = (timeStr = "00:00") => {
    const [m = 0, s = 0] = timeStr.split(":").map(Number);
    return m * 60 + s;
};


const Stage2 = ({ updateHeader }) => {
    useEffect(() => {
        updateHeader({ backButtonRedirect: "/stage2" });


    }, []); // run once on mount
    const navigate = useNavigate();
    const [totalScore, setTotalScore] = useState(0);

    const [points, setPoints] = useState(0);
    const [clickedItems, setClickedItems] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);

    const [initialTime, setInitialTime] = useState(null);
    const [ready, setReady] = useState(false);
    const [stageCompleted, setStageCompleted] = useState(false);

    const [SESSION_KEY, setSessionKey] = useState(null);
    const [seconds, setSeconds] = useState(0);
    const [minutes, setMinutes] = useState(0);

    // const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
    const [userData, setUserData] = useState({});
    const [userInteracted, setUserInteracted] = useState(false);

    useEffect(() => {
        const storedUserData = sessionStorage.getItem("userData");
        if (storedUserData) {
            setUserData(JSON.parse(storedUserData));
        }
    }, []);


    const [isMobilePortrait, setIsMobilePortrait] = useState(false);

    useEffect(() => {
        const checkScreen = () => {
            setIsMobilePortrait(
                window.innerWidth <= 768 && window.innerHeight > window.innerWidth
            );
        };

        checkScreen(); // initial
        window.addEventListener("resize", checkScreen);

        return () => window.removeEventListener("resize", checkScreen);
    }, []);






    useEffect(() => {
        const loadStageData = async () => {
            if (!userData?.userId) return;

            try {
                const res = await fetchReport({
                    userId: userData.userId,
                    sessionId: userData.sessionId,
                    organizationId: userData.organizationId,
                    stage: STAGE,
                });

                if (userData?.organizationId === "demobypass") {
                    window.location.href = `${process.env.REACT_APP_BASE_URL}/plans`;
                    return; // stop further execution
                }

                if (res.status === "success") {
                    setPoints(res.points || 0);
                    setTotalScore(res.total_score || 0); // ✅ ADD THIS
                    setInitialTime(res.time || "00:00");

                    if ((res.points || 0) === TOTAL_ITEMS.length) {
                        setClickedItems([...TOTAL_ITEMS]);
                    }
                } else {
                    setInitialTime("00:00");
                }
            } catch (err) {
                console.error("Fetch stage report failed", err);
                setInitialTime("00:00");
            } finally {
                setReady(true);
            }
        };

        loadStageData();
    }, [userData]);







    useEffect(() => {
        if (!modalOpen || clickedItems.length === TOTAL_ITEMS.length) return;

        const attachSvgEvents = () => {
            const obj = document.querySelector(".svg-object");
            if (!obj?.contentDocument) return;

            const svg = obj.contentDocument.querySelector("svg");
            if (!svg) return;

            // 🔥 Mobile safety
            svg.style.touchAction = "none";

            TOTAL_ITEMS.forEach((id) => {
                const g = svg.getElementById(id);
                if (!g) return;

                // ✅ RE-APPLY highlight if already found
                if (clickedItems.includes(id)) {
                    // g.querySelectorAll("text").forEach((t) => {
                    //     t.style.fill = "red";
                    // });
                    g.querySelectorAll("text, path").forEach((el) => {
                        el.style.fill = "red";
                    });

                    return; // skip event binding
                }

                // ✅ Enable clicking
                g.style.pointerEvents = "all";
                g.style.cursor = "pointer";

                g.querySelectorAll("*").forEach((el) => {
                    el.style.pointerEvents = "all";
                });

                const handleSelect = (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    setUserInteracted(true);

                    setClickedItems((prev) => {
                        if (prev.includes(id)) return prev;

                        // 🔴 Highlight immediately
                        // g.querySelectorAll("text").forEach((t) => {
                        //     t.style.fill = "red";
                        // });
                        g.querySelectorAll("text, path").forEach((el) => {
                            el.style.fill = "red";
                        });



                        setPoints((p) => p + 1);
                        return [...prev, id];
                    });
                };

                // ✅ Desktop + Mobile
                g.addEventListener("click", handleSelect);
                g.addEventListener("pointerdown", handleSelect);
            });
        };

        const timer = setTimeout(attachSvgEvents, 1500);
        return () => clearTimeout(timer);
    }, [modalOpen, clickedItems]);


    /* 🔹 Completion logic */
    useEffect(() => {
        if (!userInteracted) return;
        if (stageCompleted) return;
        console.log("cliked items", clickedItems);
        console.log("totl item  items", TOTAL_ITEMS.length);
        if (clickedItems.length !== TOTAL_ITEMS.length) return;

        console.log("inserting");
        // stopTimer();
        setModalOpen(false);
        updateStage2Report();

        // Swal.fire({
        //     imageUrl: suspectImg,
        //     imageAlt: "Suspects",
        //     showConfirmButton: false,
        //     allowOutsideClick: false,
        //     timer: 5000,
        //     background: "transparent",
        // });

        // setTimeout(() => Swal.close(), 4000);
        // const t = setTimeout(() => navigate("/stage3"), 5000);
        // return () => clearTimeout(t);
        Swal.fire({
            imageUrl: suspectImg,
            imageAlt: "Suspects",
            showConfirmButton: false,
            showCloseButton: true, // ✅ Top-right close icon
            allowOutsideClick: false,
            background: "transparent",
            customClass: {
                closeButton: "swal-close-btn",
            },
            didClose: () => {
                navigate("/stage3"); // ✅ Redirect after close
            },
        });


    }, [clickedItems, points]);

    const updateStage2Report = async () => {
        if (!userData?.reportId) return;
        console.log("total score---", totalScore);

        try {
            await updateReport({
                sessionId: userData.sessionId,
                userId: userData.userId,
                organizationId: userData.organizationId,
                reportId: userData.reportId,
                stage: STAGE,
                score: points + totalScore,
                time: formattedTime,
                roles: userData.roles,
                token: userData.token || ""
            });
            setStageCompleted(true);
        } catch (err) {
            console.error("Stage2 update failed", err);
        }
    };

    useEffect(() => {
        if (!stageCompleted) return;
        return () => {
            Swal.close();
        };
    }, []);



    useEffect(() => {

        const checkStageCompletion = async () => {
            try {
                const res = await fetchReport({
                    userId: userData.userId,
                    sessionId: userData.sessionId,
                    organizationId: userData.organizationId,
                    stage: STAGE,
                });

                if (userData?.sessionId && userData?.userId) {
                    const key = `stage_timer_${userData.sessionId}_${userData.userId}`;
                    setSessionKey(key);

                    if (!sessionStorage.getItem(key)) {
                        sessionStorage.setItem(
                            key,
                            JSON.stringify({
                                userId: userData.userId,
                                sessionId: userData.sessionId,
                                startTime: Date.now(),
                            })
                        );
                    }
                }
                console.log("data2", res);
                if (Number(res?.points) !== 0) {
                    Swal.close();
                    navigate("/stage3", { replace: true });
                }


            } catch (err) {
                console.error("Stage check failed", err);
            }
        };

        if (userData?.sessionId) {
            checkStageCompletion();
        }
    }, [navigate, userData]);

    // useEffect(() => {
    //     const sessionData = sessionStorage.getItem(SESSION_KEY);

    //     if (!sessionData) return;

    //     const { startTime } = JSON.parse(sessionData);

    //     const interval = setInterval(() => {
    //         const elapsedMs = Date.now() - startTime;
    //         const totalSeconds = Math.floor(elapsedMs / 1000);

    //         const mins = Math.floor(totalSeconds / 60);
    //         const secs = totalSeconds % 60;

    //         setMinutes(mins);
    //         setSeconds(secs);
    //     }, 1000);

    //     return () => clearInterval(interval);
    // }, [SESSION_KEY]);



    useEffect(() => {
        if (!initialTime) return;

        const baseSeconds = timeToSeconds(initialTime);
        const startTime = Date.now();

        const interval = setInterval(() => {
            const elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
            const totalSeconds = baseSeconds + elapsedSeconds;

            setMinutes(Math.floor(totalSeconds / 60));
            setSeconds(totalSeconds % 60);
        }, 1000);

        return () => clearInterval(interval);
    }, [initialTime]);



    const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    return (
        <div className="stage2_wrapper">
            <div className="stage2">
                <div className="row header2">
                    <div className="timer-22">
                        Time: {formattedTime}
                    </div>
                    <div className="title-wrap-2">  <h4 className="gameHead-22">
                        Phone Records: Decode the data to identify the suspects
                    </h4>
                        <p className="gameSubHead-2">
                            Click to look at the phone records
                        </p>
                    </div>

                    <div className="score-22">Points: {totalScore}</div>
                </div>

                <div className="main">
                    <div
                        className="lap"
                        onClick={() =>
                            clickedItems.length !== TOTAL_ITEMS.length &&
                            setModalOpen(true)
                        }
                    >
                        {/* <img src={lapImg} alt="Laptop" /> */}
                    </div>
                </div>

                <Modal
                    isOpen={modalOpen}
                    onRequestClose={() => setModalOpen(false)}
                    className="stage2-modal"
                    overlayClassName="stage2-overlay"
                >
                    <span
                        className="close"
                        onClick={() => setModalOpen(false)}
                    >
                        ×
                    </span>
                    <h4 className="svg-title2">
                        Spot the numbers that look suspicious.
                    </h4>


                    <object
                        type="image/svg+xml"
                        data={
                            isMobilePortrait
                                ? "/img/call_list_mob.svg"
                                : "/img/call_list.svg"
                        }
                        className="svg-object"
                    />

                </Modal>
            </div>
        </div>
    );
};

export default Stage2;
